module.exports = __webpack_public_path__ + "assets/img/btn-download-hover-611edb79.png";